var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.test)?_c('div',[(_vm.test.testInProcess && _vm.questions)?_c('test-progress'):(_vm.test.result)?[_c('test-result')]:[_c('test-start-info',{attrs:{"test":_vm.test}})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }